import { useState, useRef, useEffect, useMemo } from "react"
import { Wheel } from 'react-custom-roulette'
import { WheelData } from 'react-custom-roulette/dist/components/Wheel/types'
import base from '../assets/img/base.png'
import centro from '../assets/img/centro.png'
import pestaña from '../assets/img/pestaña.png'
import buttonImg from '../assets/img/boton.png'
import buttonImg2 from '../assets/img/boton2.png'
import descuento10 from '../assets/img/10.png'
import descuento5 from '../assets/img/5.png'
import lose from '../assets/img/prox.png'
import premio from '../assets/img/premio.png'
import btnFullScreen from '../assets/img/expand-solid.svg'

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function Roulette() {
    const [mustSpin, setMustSpin] = useState(false);
    const [prizeNumber, setPrizeNumber] = useState(0);
    const [showBtn, setShowBtn] = useState(buttonImg);
    const [open, setOpen] = useState(false);
    const [msg, setMensaje] = useState("");
    const ganador = useRef(false);
    
    // Estado para el multiplicador de tamaño de imágenes (responsivo)
    const [sizeMultiplier, setSizeMultiplier] = useState(2);
    const multiplierRef = useRef(2);
    const [wheelKey, setWheelKey] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [wheelSize, setWheelSize] = useState(775);
    const mustSpinRef = useRef(false);

    // Calcular el multiplicador basado en el viewport
    useEffect(() => {
        let resizeTimeout: NodeJS.Timeout;
        
        const updateMultiplier = () => {
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            
            // Base: 775px es el ancho original de tu rueda
            const baseSize = 775;
            
            // Determinar si estamos en fullscreen
            const isFullscreen = !!document.fullscreenElement;
            
            // Calculamos el tamaño disponible
            // En fullscreen, siempre usamos el menor entre ancho y alto
            const percentage = isFullscreen ? 0.85 : 0.9;
            const minViewport = Math.min(vw, vh);
            const availableSize = minViewport * percentage;
            
            // Calculamos el tamaño real de la rueda (debe ser cuadrado)
            const newWheelSize = Math.min(availableSize, baseSize);
            setWheelSize(newWheelSize);
            
            // Calculamos el factor de escala
            const scaleFactor = newWheelSize / baseSize;
            
            // Ajustamos el sizeMultiplier según el tamaño del dispositivo
            // Base es 2, pero lo aumentamos en dispositivos más pequeños
            let baseMultiplier = 2;
            
            // En mobile (menos de 768px), aumentamos el multiplicador
            if (vw < 768) {
                baseMultiplier = 2.5; // Aumentamos 25%
            } 
            // En tablet (768px a 1024px), aumentamos un poco
            else if (vw < 1025) {
                baseMultiplier = 2.2; // Aumentamos 10%
            }
            
            // El sizeMultiplier final es el base multiplicado por el factor de escala
            const newMultiplier = baseMultiplier * scaleFactor;
            
            console.log('VW:', vw, 'VH:', vh, 'WheelSize:', newWheelSize, 'Multiplier:', newMultiplier, 'Fullscreen:', isFullscreen, 'BaseMultiplier:', baseMultiplier);
            
            // Solo actualizamos si no está girando
            if (!mustSpinRef.current) {
                setSizeMultiplier(newMultiplier);
            }
            multiplierRef.current = newMultiplier;
        };

        // Pequeño delay para asegurar que el DOM se haya actualizado
        const handleFullscreenChange = () => {
            const isNowFullscreen = !!document.fullscreenElement;
            setIsFullscreen(isNowFullscreen);
            
            setTimeout(() => {
                updateMultiplier();
                // Forzar re-render del componente Wheel cambiando su key
                setWheelKey(prev => prev + 1);
            }, 300);
        };

        // Debounce para el evento resize
        const handleResize = () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateMultiplier, 150);
        };

        updateMultiplier();
        window.addEventListener('resize', handleResize);
        window.addEventListener('fullscreenchange', handleFullscreenChange);
        window.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        window.addEventListener('mozfullscreenchange', handleFullscreenChange);
        window.addEventListener('MSFullscreenChange', handleFullscreenChange);
        
        return () => {
            clearTimeout(resizeTimeout);
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('fullscreenchange', handleFullscreenChange);
            window.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            window.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            window.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    // Usamos useMemo para que el array data no se recree en cada render
    const data: WheelData[] = useMemo(() => {
        console.log('Recreando data array con sizeMultiplier:', sizeMultiplier);
        return [
            { image: { uri: premio, sizeMultiplier }, style: { backgroundColor: "#ffd500" } },
            { image: { uri: lose, sizeMultiplier } },
            { image: { uri: descuento10, sizeMultiplier }, style: { backgroundColor: "#fff" } },
            { image: { uri: lose, sizeMultiplier } },
            { image: { uri: descuento5, sizeMultiplier }, style: { backgroundColor: "#fff" } },
            { image: { uri: lose, sizeMultiplier } },
            { image: { uri: descuento10, sizeMultiplier }, style: { backgroundColor: "#fff" } },
            { image: { uri: lose, sizeMultiplier } },
            { image: { uri: descuento5, sizeMultiplier }, style: { backgroundColor: "#fff" } },
            { image: { uri: lose, sizeMultiplier } },
            { image: { uri: descuento5, sizeMultiplier }, style: { backgroundColor: "#fff" } },
            { image: { uri: lose, sizeMultiplier } }
        ];
    }, [sizeMultiplier]);

    const Pointer = {
        src: pestaña,
    };

    const handleClose = () => setOpen(false);

    const launchFullScreen = () => {
        const element = document.documentElement;
        
        if (!document.fullscreenElement) {
            // Entrando a pantalla completa
            element.requestFullscreen();
        } else {
            // Saliendo de pantalla completa
            document.exitFullscreen();
        }
    };

    const handleSpinClick = async() => {
        if (!mustSpin) {
            const newPrizeNumber = Math.floor(Math.random() * data.length);           
            setPrizeNumber(newPrizeNumber);
            mustSpinRef.current = true;
            setMustSpin(true);
            
            // Cambiamos el botón después de un frame
            requestAnimationFrame(() => {
                setShowBtn(buttonImg2);
            });
        }
    };
    
    return (
        <div className="ruletaContainer">
            <a id="buttonFull" onClick={launchFullScreen}>
                <img src={btnFullScreen} className='imgFullScreen' alt="Pantalla completa" />
            </a>
            
            <div className="wheelWrapper">
                <img src={base} className="imgBaseStyle" alt="Base" />
                
                <div className="wheelContent">
                    <Wheel
                        key={wheelKey}
                        mustStartSpinning={mustSpin}
                        prizeNumber={prizeNumber}
                        data={data}
                        backgroundColors={['#a9518f', '#713882']}
                        textColors={['#ffffff', '#a9518f', '#ffffff', '#ffffff', '#ffffff', '#ffffff']}
                        outerBorderWidth={0}
                        radiusLineWidth={0}
                        innerRadius={20}
                        innerBorderWidth={0}
                        fontSize={14}
                        textDistance={65}
                        spinDuration={0.3}
                        pointerProps={Pointer}
                        perpendicularText={true}
                        disableInitialAnimation={true}
                        onStopSpinning={() => {
                            mustSpinRef.current = false;
                            setMustSpin(false);
                            // Cambiamos el botón en el siguiente frame
                            requestAnimationFrame(() => {
                                setShowBtn(buttonImg);
                            });
                            
                            // Determinamos el mensaje según el premio
                            let mensaje = "";
                            const premioGanado = data[prizeNumber];
                            
                            if (premioGanado && premioGanado.image) {
                                const imagenGanadora = premioGanado.image.uri;
                                
                                if (imagenGanadora === lose) {
                                    mensaje = "¡Seguí participando!";
                                } else if (imagenGanadora === descuento5) {
                                    mensaje = "¡Ganaste 5% de descuento en tu próxima compra!";
                                } else if (imagenGanadora === descuento10) {
                                    mensaje = "¡Ganaste 10% de descuento en tu próxima compra!";
                                } else if (imagenGanadora === premio) {
                                    mensaje = "¡FELICITACIONES! ¡Ganaste el premio mayor!";
                                }
                            }
                            
                            setMensaje(mensaje);
                            
                            // Mostramos el modal después de un pequeño delay
                            setTimeout(() => {
                                setOpen(true);
                            }, 500);
                        }}
                    />
                </div>
                
                <img src={centro} className="imgCentroStyle" alt="Centro" />
            </div>

            <a id="buttonJuga" onClick={handleSpinClick}>
                <img src={showBtn} alt="Jugar" className="btnJugarImg" />
            </a>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: '20px',
                        padding: '20px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                    }
                }}
            >
                <DialogTitle 
                    id="alert-dialog-title" 
                    style={{ 
                        textAlign: 'center', 
                        fontSize: '2rem', 
                        fontWeight: 'bold',
                        color: '#fff',
                        paddingTop: '20px',
                        paddingBottom: '10px',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
                    }}
                >
                    {msg.includes("FELICITACIONES") ? "🎉 ¡FELICITACIONES! 🎉" : 
                     msg.includes("10%") ? "🎊 ¡Ganador! 🎊" :
                     msg.includes("5%") ? "🎁 ¡Ganaste! 🎁" : 
                     "😊 ¡Mejor suerte la próxima! 😊"}
                </DialogTitle>
                <DialogContent style={{ paddingTop: '20px', paddingBottom: '30px' }}>
                    <DialogContentText 
                        id="alert-dialog-description" 
                        style={{ 
                            textAlign: 'center', 
                            fontSize: '1.4rem',
                            color: '#fff',
                            fontWeight: '500',
                            lineHeight: '1.6'
                        }}
                    > 
                        {msg}                   
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ justifyContent: 'center', paddingBottom: '20px' }}>
                    <Button 
                        size="lg" 
                        onClick={handleClose} 
                        autoFocus
                        style={{
                            backgroundColor: '#fff',
                            color: '#764ba2',
                            border: 'none',
                            borderRadius: '50px',
                            padding: '12px 50px',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                            transition: 'all 0.3s ease',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.3)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                        }}
                    >
                        Continuar
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}